import type { AppContent } from '../dal/contentful-types'
import type { User } from '../dal/user-dal'

type VoiceAssessmentSessionDefinitionParams = {
  app: Pick<AppContent, 'sessionDefinition'>
  user?: Pick<User, 'voiceType'> | null
}

export function getVoiceAssessmentSessionDefinitionId({
  app,
  user,
}: VoiceAssessmentSessionDefinitionParams): number {
  const voiceTypeKey = user?.voiceType ?? 'unknown'
  return app.sessionDefinition[voiceTypeKey]
}

export function getVoiceAssessmentSessionDefinitionIds(
  app: Pick<AppContent, 'sessionDefinition'>,
): number[] {
  return [...new Set(Object.values(app.sessionDefinition))]
}

/**
 * Historical context:
 *
 * The selected session definition now comes from Contentful
 * `TypeApp.sessionDefinition`, keyed by the user's backend `voiceTypeId`.
 *
 * The number of measurements and progress steps for this flow are not
 * hardcoded in the app: they come from `measurementDefinitions` on the
 * session definition returned by the API for this id (see
 * `sessionDefinitionQueryOptions` / `VoiceAssessmentFlow`).
 */
